import { getECargoEnvironment } from './ECargoEnvironment.js'
import rg4js from 'raygun4js'
import { cloneWithRedactedPasswordProperties } from "./RaygunUtilities.ts";

function getDebugModeBasedOnCurrentECargoEnvironment() {
    switch(getECargoEnvironment()) {
        case 'production':
        case 'uat':
            return false;
        default:
            return true;
    }
}

function getApiKeyBasedOnCurrentECargoEnvironment() {
    switch(getECargoEnvironment()) {
        case 'production':
            return '8pTsWX/IY6wqviJbglmUTg==';
        case 'uat':
            return '34cACFOWJ6ulvgw9WqZAcg==';
        default:
            return 'KpbOOdN7CvcvDDywHUGFNg==';
    }
}

//custom configuration of Raygun
rg4js('options', {
    debugMode: getDebugModeBasedOnCurrentECargoEnvironment()
});
rg4js('setVersion', ECARGO_APP_VERSION);
rg4js('logContentsOfXhrCalls', true);
rg4js('onBeforeSend', function (payload) {
    const sensitiveRequests = [];
    const sensitiveDataEndpointPaths = [
        '/FrontEndApi/Password/ChangePassword',
        '/FrontEndApi/Password/ResetPassword',
        '/FrontEndApi/SignIn/SetAuthenticationCookie'
    ];

    payload.Details.Breadcrumbs.forEach(function(bc) {
        if(bc.type === "request" &&
          bc.CustomData.method === "POST" &&
          sensitiveDataEndpointPaths.some(endpoint => bc.CustomData.requestURL.endsWith(endpoint)))
            sensitiveRequests.push(bc);
    });

    sensitiveRequests.forEach(function(r) {
        const requestContent = JSON.parse(r.CustomData.body);
        r.CustomData.body = JSON.stringify(cloneWithRedactedPasswordProperties(requestContent));
    });

    if(payload.Details.UserCustomData) {
        payload.Details.UserCustomData = cloneWithRedactedPasswordProperties(payload.Details.UserCustomData);
    }

    return payload;
});

if(import.meta.env.PROD /* replaced by Vite at build time */)
    rg4js('enableCrashReporting', true);

rg4js('apiKey', getApiKeyBasedOnCurrentECargoEnvironment());

export { rg4js }
